import { Component, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as HighCharts from 'highcharts';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-dr-events-details',
    templateUrl: './dr-events-details.component.html',
    styleUrls: ['./dr-events-details.component.scss']
})
export class DrEventsDetailsComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private translateService: TranslateService,
        private dialogRef: MatDialogRef<DrEventsDetailsComponent>) {
    }

    demandResponseInfo = [
        { label: 'app.device', value: this.data.demandResponseInfo.deviceName },
        { label: 'app.start-date', value: this.data.demandResponseInfo.startDate.split('+')[0] },
        { label: 'app.end-date', value: this.data.demandResponseInfo.endDate.split('+')[0] },
        { label: 'app.period', value: this.data.demandResponseInfo.period },
        { label: 'app.completion', value: `${this.data.completionPercentage} %` },
        ...(this.data.demandResponseInfo.divergence
          ? [{ label: 'app.divergence', value: `${this.data.demandResponseInfo.divergence.toFixed(2)} kWh` }]
          : []),
      ];
      
    ngOnInit(): void {
        const dtStartList: string[] = this.data['demandResponseProfiles'].map(entry => entry.dtStart);
        const valueList: number[] = this.data['demandResponseProfiles'].map(entry => entry.value);

        HighCharts.chart('demandProfiles', {
            credits: {
                enabled: false
            },
            title: {
                text: ''
            },
            xAxis: [{
                categories: dtStartList,
                //crosshair: true
                tickInterval: 5,
            }],
            yAxis: [{
                labels: {
                    format: '{value}',
                },
                title: {
                    text: '',
                }
            }, {
                title: {
                    text: '',
                },
                labels: {
                    format: '{value}',

                },
                opposite: true
            }],
            tooltip: {
                shared: true
            },
            series: [{
                name: 'value',
                type: 'column',
                yAxis: 1,
                data: valueList,
                tooltip: {
                    valueSuffix: 'W',
                    pointFormat: '{series.name}: <b>{point.y:.2f}</b><br/>'
                }
            }],
            colors: [
                "#a8dcf0", "#ff6933"
            ],
        });
    }

    save() {
        this.close();
    }

    close() {
        this.dialogRef.close();
    }

}
